import { IDynamicLinkedServiceTypeMetadata, ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { format } from 'app/shared/utils/string.util';
import { supportedMongoDbTypes } from 'app/registries/consts/tabular-consts';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { connectionString } from 'app/shared/utils/connector-metadata-static-consts';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { GlobalVariables } from 'app/services/globals';

export const nativemongoDbMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata: ILinkedServiceTypeMetadata = {
        type: adfModelTypeMap.mongoDb.linkedServiceType,
        displayName: stringResources.MongoDb_DisplayText,
        linkedServiceKind: 'hierarchical',
        icon: {
            className: 'svg-i-100x100-MongoDBCollection'
        },
        tableNameAlias: 'collection',
        queryAlias: 'filter',
        isFirstClass: true,
        supportedInTrident: true,
        supportCopyJobSource: true,
        supportCopyJobSink: true,
        supportedJobModesAsSource: GlobalVariables.copyJobIncrementalCopyPhase2 ? undefined : ['Batch'],
        supportAutoFillCopilotInput: true,
        isKnownInPipelineContext: true,
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'MongoDBForPipeline' as ResourceKind
        },
        supportOPDG: GlobalVariables.enableOPDG,
        tableColumnNameQuotes: ['"', '"'],
        supportDatasetV2: true,
        copySinkTypes: [adfModelTypeMap.mongoDb.copySinkType],
        copySourceTypes: [adfModelTypeMap.mongoDb.copySourceType],
        category: ['NoSQL'],
        onetimeQueryTemplate: '{\n<<columnName>>: filterValue\n}',
        timedQueryTemplate: '{\n<<columnName>>: {\n$gte: ISODate(\'@{formatDateTime(pipeline().parameters.windowStart)}\'),\n$lt: ISODate(\'@{formatDateTime(pipeline().parameters.windowEnd)}\')}\n}',
        deltaLoadQueryTemplate: `{<<columnName>>: {
        $gte: @{if(contains(json(item().DataLoadingBehaviorSettings).watermarkColumnType, 'Int'),
            json(item().DataLoadingBehaviorSettings).watermarkColumnStartValue,
            concat('ISODate(''', formatDateTime(json(item().DataLoadingBehaviorSettings).watermarkColumnStartValue), ''')'))},
        $lt: @{if(contains(json(item().DataLoadingBehaviorSettings).watermarkColumnType, 'Int'),
            activity('GetMaxWatermarkValue').output.firstRow.CurrentMaxWaterMarkColumnValue,
            concat('ISODate(''', formatDateTime(activity('GetMaxWatermarkValue').output.firstRow.CurrentMaxWaterMarkColumnValue), ''')'))},
    }}`,
        linkedServiceNamePrefix: 'MongoDb',
        controls: [
            {
                type: 'select-button-switch',
                required: true,
                isLabelVertical: true,
                options: [
                    {
                        label: stringResources.ModelName_ConnectionString,
                        value: false
                    },
                    {
                        label: stringResources.AzureKeyVault_DisplayText,
                        value: true
                    }
                ],
                bind: 'enableAKV',
                isNotRelatedToCredential: true,
                defaultValue: false,
                cases: [
                    {
                        caseValue: true,
                        children: [
                            {
                                type: 'azure-key-vault',
                                bind: 'referedAKV',
                                isLabelVertical: true,
                                description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template_ConnectionStringWithSample,
                                    format(stringResources.ModelName_LinkedServiceTemplate, stringResources.MongoDb_DisplayText),
                                    connectionString)
                            },
                            {
                                type: 'textbox',
                                bind: 'databaseName',
                                label: stringResources.ModelName_DatabaseName,
                                required: true,
                                validators: [
                                    { type: 'required', errorMessage: '' }
                                ],
                                isLabelVertical: true
                            }
                        ]
                    },
                    {
                        caseValue: false,
                        children: [
                            {
                                type: 'mongo-db-select',
                                bind: {
                                    connectionString: 'connectionString',
                                    databaseName: 'databaseName'
                                },
                                mongoDbType: 'native' as supportedMongoDbTypes,
                                validators: {
                                    connectionString: [
                                        { type: 'required', errorMessage: '' }
                                    ],
                                    databaseName: [
                                        { type: 'required', errorMessage: '' }
                                    ]
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return metadata;
}
